export default  function valiisValidInputdate(value, type) {

    const v = String(value ?? "").trim();

    switch ((type || "").toLowerCase()) {

        case "required":
            return v.length > 0;

        case "email":
            return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(v);

        case "codice_fiscale":
        case "cf":
            return /^[A-Z0-9]{16}$/i.test(v);

        case "partita_iva":
        case "piva":
            return /^[0-9]{11}$/.test(v);

        case "domain":
        case "dominio":
            if (!v || /^https?:\/\//i.test(v) || /^www\./i.test(v)) return false;
            return /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/.test(v);

        case "phone":
        case "telefono":
            return /^[0-9+\s().-]{6,20}$/.test(v);

        default:
            return true; // se il tipo non è gestito → considerato valido
    }
}
